// extracted by mini-css-extract-plugin
module.exports = {"page":"dY","account":"eY","pdp":"fY","cart":"gY","brand":"hY","cartModal":"iY","checkout":"jY"};